export default "__VITE_ASSET__VBybYuod__"